import store from '@/store/store';
import genererParametrageGenerique from '@/services/parametrage/generation/genererParametrageGenerique';
import { create } from '@/api/parametre/';

export default async function completeParametrageGeneriqueNonExistant(type,
  listeLibelle, newItemObject) {
  await store.dispatch('parametres/loadParametres', [type]);
  const itemsParam = store.getters['parametres/parametre'](type);
  let reqSurItem = [];
  [...new Set(listeLibelle)].forEach((libelle) => {
    if (libelle === undefined) return;
    const isInParam = itemsParam.find((c) => {
      return c.libelle.toLowerCase() === libelle.toLowerCase();
    });
    if (!isInParam) {
      const newItem = newItemObject || genererParametrageGenerique();
      newItem.libelle = libelle;
      reqSurItem.push(create(type, newItem));
    }
  });
  if (reqSurItem.length) {
    await Promise.all(reqSurItem);
    reqSurItem = [];
    await store.dispatch('parametres/loadParametreForce', [type]);
  }
}
